export default "__VITE_ASSET__DMl_lpzJ__"